import { functions } from '@/plugins/firebase';
import { getSeasonYear } from '@/store/seasonYear';
const OFFLINE_CODES = ['unavailable', 'deadline-exceeded', 'functions/unavailable', 'functions/deadline-exceeded'];
export const OFFLINE_MESSAGE = 'Bez připojení k internetu. Změna nebyla uložena.';
export class CallableError extends Error {
    code;
    details;
    constructor(code, message, details) {
        super(message);
        this.code = code;
        this.details = details;
        this.name = 'CallableError';
    }
}
/** The calls still on the wire, so the same one cannot be sent twice. */
const pending = new Map();
async function invoke(name, payload) {
    const fn = functions.httpsCallable(name);
    try {
        const result = await fn({ ...payload, season: getSeasonYear() });
        return result.data;
    }
    catch (e) {
        if (e.code && e.message) {
            const offline = OFFLINE_CODES.includes(e.code) || !navigator.onLine;
            const message = offline ? OFFLINE_MESSAGE : e.message;
            throw new CallableError(e.code, message, e.details);
        }
        throw e;
    }
}
/**
 * A second click while the first call is still running gets the promise of that
 * call instead of sending the same thing again - a double click on `+1 hour`
 * added two. `saveWorkTable` carries a fresh `changedAt`, so two saves of one
 * table are never the same payload: there the merge decides, as it should.
 *
 * The payload of one action is built in one place, so its key order is stable.
 */
export function callFn(name, payload = {}) {
    const key = `${name}:${JSON.stringify(payload)}`;
    const running = pending.get(key);
    if (running) {
        return running;
    }
    const call = invoke(name, payload).finally(() => pending.delete(key));
    pending.set(key, call);
    return call;
}
